const d = {
  "cdr-modal": "cdr-modal_16-3-1",
  "cdr-modal__overlay": "cdr-modal__overlay_16-3-1",
  "cdr-modal__outerWrap": "cdr-modal__outerWrap_16-3-1",
  "cdr-modal__contentWrap": "cdr-modal__contentWrap_16-3-1",
  "cdr-modal__innerWrap": "cdr-modal__innerWrap_16-3-1",
  "cdr-modal__dialog": "cdr-modal__dialog_16-3-1",
  "cdr-modal__content": "cdr-modal__content_16-3-1",
  "cdr-modal__header": "cdr-modal__header_16-3-1",
  "cdr-modal__title": "cdr-modal__title_16-3-1",
  "cdr-modal__close-button": "cdr-modal__close-button_16-3-1",
  "cdr-modal__text-content": "cdr-modal__text-content_16-3-1",
  "cdr-modal--closed": "cdr-modal--closed_16-3-1"
};
export {
  d as default
};
